import api from './axios';

export const getSoldProducts = () => api.get('/reports/sold-products');

export const getProductSales = (period = 30) =>
  api.get('/reports/product-sales', { params: { period } });

export const getDues = () => api.get('/reports/dues');
